'use strict';

import _ from 'lodash';

import React from 'react';

export default function(text) {
	return _.map(text.split('\n'), (line, index) => (
		<span key={index}>
			{line}
			<br />
		</span>
	));
}
